import React from "react";

import { finishSentence } from "../../generic/stringUtils";
import { Link } from "../react/link/Link"; // keep full import path to prevent dependency cycle

interface NotificationReadMoreMessageProps {
	message: string;
	error: unknown;
	onReadMore?: VoidFunction;
	onRetry?: VoidFunction;
}

export const NotificationErrorMessage: React.FC<NotificationReadMoreMessageProps> = ({
	message,
	error,
	onReadMore,
	onRetry,
}) => {
	if (error == null) {
		return <>{message}</>;
	}

	return (
		<div className="space-x-1.5" data-testid="notification-read-more-message">
			<span>{finishSentence(message)}</span>
			{onReadMore != null && (
				<Link el="button" onClick={onReadMore} theme="secondary">
					Read more
				</Link>
			)}
			{onRetry && (
				<Link el="button" onClick={onRetry} theme="secondary">
					Retry
				</Link>
			)}
		</div>
	);
};
